import { render, staticRenderFns } from "./editGen.vue?vue&type=template&id=5fd1006b&scoped=true&"
import script from "./editGen.vue?vue&type=script&lang=js&"
export * from "./editGen.vue?vue&type=script&lang=js&"
import style0 from "./editGen.vue?vue&type=style&index=0&id=5fd1006b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1006b",
  null
  
)

export default component.exports